import { render, staticRenderFns } from "./visitorDiscern.vue?vue&type=template&id=5940dd51"
import script from "./visitorDiscern.vue?vue&type=script&lang=js"
export * from "./visitorDiscern.vue?vue&type=script&lang=js"
import style0 from "./visitorDiscern.vue?vue&type=style&index=0&id=5940dd51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports